// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#keeptrack-root {
  line-height: 1.15;
}

#keeptrack-canvas {
  background: var(--colorBlack);
  /* Inconsistent brightness without this */
  z-index: 0;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  touch-action: auto;
}

#sat-hoverbox {
  display: none;
  background: black;
  cursor: default;
  color: white;
  font-family: -apple-system, BlinkMacSystemFont, 'Open Sans', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;
  position: absolute;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  pointer-events: none;
}

#orbit-btn {
  display: block;
  background: red;
  position: relative;
  z-index: 99999;
  width: 5px;
  left: 0px;
  top: 500px;
  bottom: 0px;
  padding: 20px;
  border-radius: 5px;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

#countries-btn {
  display: block;
  background: green;
  position: relative;
  z-index: 99999;
  width: 5px;
  left: 0px;
  top: 500px;
  bottom: 0px;
  padding: 20px;
  border-radius: 5px;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

#time-machine-btn {
  display: block;
  background: yellow;
  position: relative;
  z-index: 99999;
  width: 5px;
  left: 0px;
  top: 500px;
  bottom: 0px;
  padding: 20px;
  border-radius: 5px;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

#toast-container {
  display: block;
  position: fixed;
  z-index: 10000;
}

.toast {
  border-radius: 2px;
  top: 35px;
  width: auto;
  margin-top: 10px;
  position: relative;
  max-width: 100%;
  height: auto;
  min-height: 48px;
  line-height: 1.5em;
  background-color: rgb(160, 232, 255);
  padding: 10px 25px;
  font-size: 1.1rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Open Sans', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;
  font-weight: 300;
  color: #000000;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  cursor: default;
}

.toast .toast-action {
  color: #eeff41;
  font-weight: 500;
  margin-right: -25px;
  margin-left: 3rem;
}

.toast.rounded {
  border-radius: 24px;
}

.right-btn-menu {
  display: none;
  background: var(--color-dark-background);
  color: white;
  position: absolute;
  width: 165px;
  border-radius: 0px;
  border: 5px solid var(--color-dark-border);
  z-index: 10;
  /*Prevent fighting with the slide down button on mobile */
}

a,
.link {
  cursor: pointer;
}

a {
  text-decoration: none;
  color: #92cbff !important;
}

.link:hover {
  background: rgba(0, 0, 0, 0.2);
}

ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

ul li {
  list-style: none;
  padding: 5px;
}

.right-btn-menu ul {
  width: 100%;
}

.right-btn-menu ul li {
  padding: 5px;
  height: 25px;
  cursor: pointer;
}

.right-btn-menu ul li:hover {
  background-color: var(--color-primary-dark);
}

.right-btn-menu ul li:hover a {
  color: var(--colorWhite) !important;
  background-color: rgba(0, 0, 0, 0);
}

.rmb-menu-item:hover {
  background-color: var(--colorPrimaryDarken3) !important;
}

.rmb-menu-item a {
  color: white !important;
}

/* MOBILE */
@media only screen and (max-width: 600px) {
  #toast-container {
    min-width: 100%;
    top: 50px;
  }

  .toast {
    width: 100%;
    border-radius: 0;
  }
}

/* TABLET */
@media only screen and (min-width: 601px) and (max-width: 992px) {
  #toast-container {
    left: 5%;
    bottom: 7%;
    max-width: 90%;
  }
}

/* DESKTOP */
@media only screen and (min-width: 993px) {
  #toast-container {
    top: 10%;
    right: 7%;
    max-width: 86%;
  }
}`, "",{"version":3,"sources":["webpack://./public/css/limitedUI.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,yCAAyC;EACzC,UAAU;EACV,MAAM;EACN,OAAO;EACP,SAAS;EACT,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,iIAAiI;EACjI,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,SAAS;EACT,UAAU;EACV,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,SAAS;EACT,UAAU;EACV,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,SAAS;EACT,UAAU;EACV,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;EACpC,kBAAkB;EAClB,iBAAiB;EACjB,iIAAiI;EACjI,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,yBAAyB;EACzB,2BAA2B;EAC3B,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,sCAAsC;EACtC,sBAAsB;EACtB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,wCAAwC;EACxC,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,WAAW;EACX,yDAAyD;AAC3D;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,uBAAuB;AACzB;;AAEA,WAAW;AACX;EACE;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA,WAAW;AACX;EACE;IACE,QAAQ;IACR,UAAU;IACV,cAAc;EAChB;AACF;;AAEA,YAAY;AACZ;EACE;IACE,QAAQ;IACR,SAAS;IACT,cAAc;EAChB;AACF","sourcesContent":["#keeptrack-root {\n  line-height: 1.15;\n}\n\n#keeptrack-canvas {\n  background: var(--colorBlack);\n  /* Inconsistent brightness without this */\n  z-index: 0;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  touch-action: auto;\n}\n\n#sat-hoverbox {\n  display: none;\n  background: black;\n  cursor: default;\n  color: white;\n  font-family: -apple-system, BlinkMacSystemFont, 'Open Sans', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;\n  position: absolute;\n  padding: 10px;\n  border-radius: 5px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  pointer-events: none;\n}\n\n#orbit-btn {\n  display: block;\n  background: red;\n  position: relative;\n  z-index: 99999;\n  width: 5px;\n  left: 0px;\n  top: 500px;\n  bottom: 0px;\n  padding: 20px;\n  border-radius: 5px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n#countries-btn {\n  display: block;\n  background: green;\n  position: relative;\n  z-index: 99999;\n  width: 5px;\n  left: 0px;\n  top: 500px;\n  bottom: 0px;\n  padding: 20px;\n  border-radius: 5px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n#time-machine-btn {\n  display: block;\n  background: yellow;\n  position: relative;\n  z-index: 99999;\n  width: 5px;\n  left: 0px;\n  top: 500px;\n  bottom: 0px;\n  padding: 20px;\n  border-radius: 5px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n#toast-container {\n  display: block;\n  position: fixed;\n  z-index: 10000;\n}\n\n.toast {\n  border-radius: 2px;\n  top: 35px;\n  width: auto;\n  margin-top: 10px;\n  position: relative;\n  max-width: 100%;\n  height: auto;\n  min-height: 48px;\n  line-height: 1.5em;\n  background-color: rgb(160, 232, 255);\n  padding: 10px 25px;\n  font-size: 1.1rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Open Sans', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;\n  font-weight: 300;\n  color: #000000;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  cursor: default;\n}\n\n.toast .toast-action {\n  color: #eeff41;\n  font-weight: 500;\n  margin-right: -25px;\n  margin-left: 3rem;\n}\n\n.toast.rounded {\n  border-radius: 24px;\n}\n\n.right-btn-menu {\n  display: none;\n  background: var(--color-dark-background);\n  color: white;\n  position: absolute;\n  width: 165px;\n  border-radius: 0px;\n  border: 5px solid var(--color-dark-border);\n  z-index: 10;\n  /*Prevent fighting with the slide down button on mobile */\n}\n\na,\n.link {\n  cursor: pointer;\n}\n\na {\n  text-decoration: none;\n  color: #92cbff !important;\n}\n\n.link:hover {\n  background: rgba(0, 0, 0, 0.2);\n}\n\nul {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n}\n\nul li {\n  list-style: none;\n  padding: 5px;\n}\n\n.right-btn-menu ul {\n  width: 100%;\n}\n\n.right-btn-menu ul li {\n  padding: 5px;\n  height: 25px;\n  cursor: pointer;\n}\n\n.right-btn-menu ul li:hover {\n  background-color: var(--color-primary-dark);\n}\n\n.right-btn-menu ul li:hover a {\n  color: var(--colorWhite) !important;\n  background-color: rgba(0, 0, 0, 0);\n}\n\n.rmb-menu-item:hover {\n  background-color: var(--colorPrimaryDarken3) !important;\n}\n\n.rmb-menu-item a {\n  color: white !important;\n}\n\n/* MOBILE */\n@media only screen and (max-width: 600px) {\n  #toast-container {\n    min-width: 100%;\n    top: 50px;\n  }\n\n  .toast {\n    width: 100%;\n    border-radius: 0;\n  }\n}\n\n/* TABLET */\n@media only screen and (min-width: 601px) and (max-width: 992px) {\n  #toast-container {\n    left: 5%;\n    bottom: 7%;\n    max-width: 90%;\n  }\n}\n\n/* DESKTOP */\n@media only screen and (min-width: 993px) {\n  #toast-container {\n    top: 10%;\n    right: 7%;\n    max-width: 86%;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
